const WHATSAPP_URL = 'https://wa.me/919003560700?text=Hello%20Lucky%20Holidays%2C%0A%0AI%20would%20like%20to%20know%20more%20about%20your%20travel%20services%20and%20customized%20holiday%20packages.%0A%0APlease%20assist%20me%20with%3A%0A-%20International%20Tours%0A-%20Domestic%20Tours%0A-%20Flight%20Bookings%0A-%20Hotel%20Reservations%0A-%20Visa%20Assistance%0A-%20Customized%20Travel%20Packages%0A%0AThank%20You.';

export default function FloatingButtons() {
  return (
    <div
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[60] flex flex-col gap-3"
      style={{ paddingBottom: 'var(--safe-area-bottom)' }}
      role="complementary"
      aria-label="Quick contact options"
    >
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 hover:scale-110 active:scale-95 transition-all duration-300 cursor-pointer animate-float"
        style={{ animationDelay: '0s' }}
        title="Chat on WhatsApp"
        aria-label="Chat with Lucky Holidays on WhatsApp"
        data-cursor-pointer="true"
      >
        <i className="ri-whatsapp-line text-lg md:text-xl" aria-hidden="true"></i>
      </a>
      <a
        href="tel:+919003560700"
        className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 hover:scale-110 active:scale-95 transition-all duration-300 cursor-pointer hover-glow-primary animate-float"
        style={{ animationDelay: '1s' }}
        title="Call Now"
        aria-label="Call Lucky Holidays at +91 90035 60700"
        data-cursor-pointer="true"
      >
        <i className="ri-phone-line text-lg md:text-xl" aria-hidden="true"></i>
      </a>
      <a
        href="https://www.instagram.com/luckyholidays.in/"
        target="_blank"
        rel="noopener noreferrer"
        className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500 text-background-50 hover:scale-110 active:scale-95 transition-all duration-300 cursor-pointer animate-float"
        style={{ animationDelay: '2s' }}
        title="Follow on Instagram"
        aria-label="Follow Lucky Holidays on Instagram"
        data-cursor-pointer="true"
      >
        <i className="ri-instagram-line text-lg md:text-xl" aria-hidden="true"></i>
      </a>
    </div>
  );
}